import React from "react";
import {Row, Col, Modal, FormGroup, Form} from 'react-bootstrap';
import {FarmBalanceTypes, OverviewHistoryTypes} from "../../common/constants";
import {getUsefulDateWithYear} from "../../common/utils";
import AccountWebOrderView from "./AccountWebOrderView";
import LoadingAnimation from "../../components/common/LoadingAnimation";
import {translate} from '../../i18n/translate.js';
import styles from "../../css/account/accountOverviewPane.less";

export default class AccountOverviewPane extends React.Component{
    constructor(props) {
        super(props);
        this.state = {description:undefined, webOrder: undefined, historyList: [], loadingHistory:true};
        this.hasBalance = this.props.staticData.farmBalanceType === FarmBalanceTypes.BALANCE_ON_ACCOUNT;
        this.desktopDescriptionColSize = this.hasBalance?4:5;
        this.mobileDebitAmountColSize = this.hasBalance?2:3;
        this.isMobile = props.clientViewPort.isXs;
    }
    setShowWebOrder(orderKey, orderDate){
        this.setState({webOrder: {orderKey, orderDate}});
    }
    setShowDescription(type, description){
        this.setState({description:{type: type, content:description}});
    }
    closeWebOrder() {
        this.setState({webOrder:undefined});
    }
    closeDescription() {
        this.setState({description:undefined});
    }
    showWebOrder() {
        return(
            <Modal show={true} onHide={this.closeWebOrder.bind(this)} dialogClassName="history-web-order">
                <Modal.Body>
                    <AccountWebOrderView
                        webOrder={this.state.webOrder}
                        onClose={this.closeWebOrder.bind(this)}/>
                </Modal.Body>
            </Modal>);
    }
    showDescription() {
        return(
            <Modal show={true} dialogClassName="history-description">
                <Modal.Title>
                    <div className="history-description-title">{this.state.description.type}
                        <div className="history-description-close" onClick={this.closeDescription.bind(this)}>X</div>
                    </div>
                </Modal.Title>
                <Modal.Body>{this.state.description.content}</Modal.Body>
            </Modal>);
    }
    componentWillMount() {
        this.getHistory(this.props)
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.history.historyList && !this.props.history.historyList) {
            this.getHistory(nextProps);
        }
    }
    getDescription(historyItem) {
        if (OverviewHistoryTypes.ORDER === historyItem.type) {
            return (<div className="history-item-link"
                         onClick={this.setShowWebOrder.bind(this, historyItem.key, historyItem.date)}>{historyItem.description}</div>)
        } else if (this.isMobile && (OverviewHistoryTypes.SUBSCRIPTION === historyItem.type)) {
            const typeName = historyItem.type === OverviewHistoryTypes.SUBSCRIPTION?"Delivery":historyItem.type;
            return (<div className="history-item-link"
                         onClick={this.setShowDescription.bind(this, typeName, historyItem.description)}>
                {typeName}</div>)
        }else if(OverviewHistoryTypes.PAYMENT === historyItem.type && historyItem.status !== "COMPLIMENTARY" && historyItem.status !== "PROCESSING"){
            return (historyItem.type);
        } else {
            return (historyItem.description);
        }
    }
    getHistory(props) {
        if(props.history.historyList) {
            let rowIndex = 0;
            const historyList = props.history.historyList.map(historyItem => {
                const balance = historyItem.balance? historyItem.balance.toFixed(2):"";
                const debit = historyItem.debit? historyItem.debit.toFixed(2):"";
                const credit = historyItem.credit? historyItem.credit.toFixed(2):"";
                const pastDate = new Date() > new Date(historyItem.date + "T12:00:00");
                const styleClassName = OverviewHistoryTypes.PENDING_PAYMENT === historyItem.type && pastDate ? ' pending-description' : '';
                const description = this.getDescription(historyItem);
                const hasBalanceStyle = !this.hasBalance?"-without-balance":""
                const showBalance = !this.props.staticData.accountHideRunningBalance;
                return (
                    <Row key={rowIndex++} className={"list-row account-history-row" + styleClassName}>
                        <Col md={2} xs={3}
                            className={"history-data-col account-history-col-date" + hasBalanceStyle}>{getUsefulDateWithYear(historyItem.date, this.isMobile)}
                        </Col>
                        <Col md={this.desktopDescriptionColSize} xs={3} className={"history-data-col account-history-col-description"+ hasBalanceStyle}>{description}
                        </Col>
                        {showBalance &&<Col md={2} xs={this.mobileDebitAmountColSize}
                            className={"history-data-col account-history-col-debit"+ hasBalanceStyle}>{debit}
                        </Col>}
                        {showBalance && <Col md={2} xs={this.mobileDebitAmountColSize}
                            className={"history-data-col account-history-col-credit"+ hasBalanceStyle}>{credit}
                        </Col>}
                        {showBalance && this.hasBalance ? <Col className="history-data-col history-data-col-balance" md={1} xs={2}>{balance}</Col> : undefined}
                    </Row>
                )
            });
            this.setState({historyList, loadingHistory:false});
        }
    }

    formatBalance(balance, dollarSign) {
      let formattedBalance = balance && (balance >= 1 || balance <= -1) ? balance.toFixed(2) : (0).toFixed(2);
      if(formattedBalance < 0) {
        formattedBalance = (dollarSign ? '-$' : '-') + formattedBalance * -1;
      } else {
        formattedBalance = (dollarSign ? '$' : '') + formattedBalance;
      }
      return formattedBalance;
    }
    render() {
        if(this.state.loadingHistory) {
            return <LoadingAnimation/>
        }
        let balance = this.formatBalance(this.props.history.balance, true)
        let creditBalance = this.formatBalance(this.props.history.creditBalance)
        const hasBalanceStyle = !this.hasBalance?"-without-balance":"";
        const showBalance = !this.props.staticData.accountHideRunningBalance;
        const showTotals = !this.props.staticData.accountHideBalanceTotals;
        const balanceLabels = this.props.staticData.accountBalanceLabel.split('|');
        const balanceLabel = balanceLabels[0];
        const creditBalanceLabel = balanceLabels.length > 1 ? balanceLabels[1] : '';
        return (<div className="account-overview-container">
            {
                this.isMobile?
                    <div className="account-header-title-container">
                        <div className="account-header-title">{translate("Overview")}</div>
                    </div>:undefined
            }
            {showTotals && <div className="account-overview-balance-row">
              <div className="account-overview-balance-container">
                  <div className="account-overview-balance-title">{balanceLabel || translate("Balance")}
                      <div className="account-overview-balance">{balance}</div>
                  </div>
              </div>
              {this.props.staticData.hasFarmigoCredits && (creditBalance > 0) &&
                  <div className="account-overview-balance-container">
                    <div className="account-overview-balance-title">{creditBalanceLabel || translate("Credit Balance")}
                      <div className="account-overview-balance">{creditBalance}</div>
                    </div>
                  </div>
              }
            </div>}
            <div className="table-container-selector">
                <Form horizontal className="list-container account-overview-list-container">
                    <FormGroup className="columns-title" controlId="accountOverviewTitles">
                        <Col md={2} xs={3} className={"title-column date-col" + hasBalanceStyle}>{translate("Date")}</Col>
                        <Col md={this.desktopDescriptionColSize} xs={3} className={"title-column description-col"+ hasBalanceStyle}>{translate(this.isMobile?"Info":"Description")}</Col>
                        {showBalance && <Col md={2} xs={this.mobileDebitAmountColSize} className={"title-column debit-col"+ hasBalanceStyle}>{translate("Debit")}</Col>}
                        {showBalance && <Col md={2} xs={this.mobileDebitAmountColSize} className={"title-column credit-col"+ hasBalanceStyle}>{translate("Credit")}</Col>}
                        {this.hasBalance && showBalance ?<Col md={1} xs={2} className="title-column balance-col">{translate("Balance")}</Col>:undefined}
                    </FormGroup>
                    {this.state.historyList}
                </Form>
            </div>
            {
                !this.state.webOrder ? undefined :
                    this.showWebOrder()
            }
            {
                this.isMobile && this.state.description?
                this.showDescription():undefined
            }
        </div>);
    }
};


// WEBPACK FOOTER //
// ./src/components/account/AccountOverviewPane.js